import { Media, Metadata, TranscodingStatus } from "./media";

export interface MediaDto extends Omit<Media, "metadata" | "versions"> {
	metadata?: MetadataDto;
}

interface MetadataDto extends Omit<Metadata, "width" | "height" | "versions" | "status"> {
	width?: string;
	height?: string;
	versions?: string;
	status?: TranscodingStatus | "ERROR";
}

export function mediaFromDto(dto: MediaDto): Media {
	const { url, metadata } = dto;
	const meta = metadata ? metadataFromDto(metadata) : undefined;
	const versions = meta?.versions ? meta.versions.map((v) => appendToFilename(url, v)) : undefined;
	return {
		...dto,
		metadata: meta,
		versions: versions,
	};
}

function appendToFilename(filename: string, version: string): string {
	const dotIndex = filename.lastIndexOf(".");
	if (dotIndex == -1) {
		return filename + version;
	}
	return filename.substring(0, dotIndex) + version + filename.substring(dotIndex);
}

export function mediaToDto(media: Media): MediaDto {
	const { versions, ...rest } = media;
	return {
		...rest,
		metadata: media.metadata && metadataToDto(media.metadata),
	};
}

function metadataFromDto(dto: MetadataDto): Metadata {
	return {
		...dto,
		width: dto.width ? +dto.width : undefined,
		height: dto.height ? +dto.height : undefined,
		versions: dto.versions ? dto.versions.split(",") : undefined,
		status: dto.status === "ERROR" ? "ON_ERROR" : dto.status,
	};
}

function metadataToDto(metadata: Metadata): MetadataDto {
	return {
		...metadata,
		width: metadata.width ? `${metadata.width}` : undefined,
		height: metadata.height ? `${metadata.height}` : undefined,
		versions: metadata.versions ? metadata.versions.join(",") : undefined,
	};
}

export enum ImageVersions {
	SMALL, // 120x120 cover
	BANNER, // 1300x300 cover
	MEDIUM, // 900x400 contain
	LARGE, // 1920 contain
}
